import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";

import InputFieldText from "Components/Common/InputFieldText";
import DateField from "Components/Common/DatePicker";

import { onlyNumberKeys } from "utils";

const BillMeterReadingFormItems = ({
  formik,
  meterReading: {
    meterNumber,
    previousMeterReading,
    activeEnergy,
    apparentEnergy,
    reactiveEnergy,
    exportEnergy,
    peakHourEnergyTOD1,
    peakHourEnergyTOD5,
    setOffImportEnergyTOD1,
    setOffExportEnergyTOD1,
    setOffImportEnergyTOD3,
    touDiscountEnergy,
    setOffExportEnergyTOD3,
    nightHourEnergy,
  },
  index,
  t,
}) => {
  const { handleChange, setFieldValue } = formik;

  return (
    <Grid
      container
      columnSpacing={1}
      className="border border-1 pt-2 pe-2 mb-2"
    >
      <Grid item xs={12}>
        <Typography className="mb-3 fw-bold" lineHeight="1" variant="h6">
          {t("Meter No")}: {meterNumber}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Active Energy") + "*"}
          name={`meterReadingsData.${index}.activeEnergy`}
          formik={formik}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.activeEnergyDifference`,
              e.target.value - previousMeterReading.activeEnergy
            );
          }}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          placeholder="Enter Active Energy"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Apparent Energy") + "*"}
          name={`meterReadingsData.${index}.apparentEnergy`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.apparentEnergyDifference`,
              e.target.value - previousMeterReading.apparentEnergy
            );
          }}
          placeholder="Enter Apparent Energy"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Reactive Energy") + "*"}
          name={`meterReadingsData.${index}.reactiveEnergy`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.reactiveEnergyDifference`,
              e.target.value - previousMeterReading.reactiveEnergy
            );
          }}
          placeholder="Enter Reactive Energy"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Export Energy") + "*"}
          name={`meterReadingsData.${index}.exportEnergy`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.exportEnergyDifference`,
              e.target.value - previousMeterReading.exportEnergy
            );
          }}
          placeholder="Enter Export Energy"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Max Demand") + "*"}
          name={`meterReadingsData.${index}.maxDemand`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          placeholder="Enter Max Demand"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Peak Hour Energy TOD1") + "*"}
          name={`meterReadingsData.${index}.peakHourEnergyTOD1`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.peakHourEnergyTOD1Difference`,
              e.target.value - previousMeterReading.peakHourEnergyTOD1
            );
          }}
          placeholder="Enter Peak Hour Energy TOD1"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Peak Hour Energy TOD5") + "*"}
          name={`meterReadingsData.${index}.peakHourEnergyTOD5`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.peakHourEnergyTOD5Difference`,
              e.target.value - previousMeterReading.peakHourEnergyTOD5
            );
          }}
          placeholder="Enter Peak Hour Energy TOD5"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Night Hour Energy") + "*"}
          name={`meterReadingsData.${index}.nightHourEnergy`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.nightHourEnergyDifference`,
              e.target.value - previousMeterReading.nightHourEnergy
            );
          }}
          placeholder="Enter Night Hour Energy"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Set Off Import Energy TOD1") + "*"}
          name={`meterReadingsData.${index}.setOffImportEnergyTOD1`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.setOffImportEnergyTOD1Difference`,
              e.target.value - previousMeterReading.setOffExportEnergyTOD1
            );
          }}
          placeholder="Enter Set Off Import Energy TOD1"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Set Off Export Energy TOD1") + "*"}
          name={`meterReadingsData.${index}.setOffExportEnergyTOD1`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.setOffExportEnergyTOD1Difference`,
              e.target.value - previousMeterReading.setOffImportEnergyTOD1
            );
          }}
          placeholder="Enter Set Off Export Energy TOD1"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Set Off Import Energy TOD3") + "*"}
          name={`meterReadingsData.${index}.setOffImportEnergyTOD3`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.setOffImportEnergyTOD3Difference`,
              e.target.value - previousMeterReading.setOffExportEnergyTOD3
            );
          }}
          placeholder="Enter Set Off Import Energy TOD3"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Set Off Export Energy TOD3") + "*"}
          name={`meterReadingsData.${index}.setOffExportEnergyTOD3`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.setOffExportEnergyTOD3Difference`,
              e.target.value - previousMeterReading.setOffImportEnergyTOD3
            );
          }}
          placeholder="Enter Set Off Export Energy TOD3"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("TOU Discount Energy") + "*"}
          name={`meterReadingsData.${index}.touDiscountEnergy`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.touDiscountEnergyDifference`,
              e.target.value - previousMeterReading.touDiscountEnergy
            );
          }}
          placeholder="Enter TOU Discount Energy"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <DateField
          label={t("Meter Reading Date")}
          name={`meterReadingsData.${index}.meterReadingDate`}
          formik={formik}
          format="DD-MM-YYYY"
          placeholder="Select Meter Reading Date"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Active Energy Difference")}
          name={`meterReadingsData.${index}.activeEnergyDifference`}
          formik={formik}
          type="number"
          disabled
          placeholder="Enter Active Energy Difference"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Apparent Energy Difference")}
          name={`meterReadingsData.${index}.apparentEnergyDifference`}
          formik={formik}
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          type="number"
          disabled
          placeholder="Enter Apparent Energy Difference"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Reactive Energy Difference")}
          name={`meterReadingsData.${index}.reactiveEnergyDifference`}
          formik={formik}
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          type="number"
          disabled
          placeholder="Enter Reactive Energy Difference"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Export Energy Difference")}
          name={`meterReadingsData.${index}.exportEnergyDifference`}
          formik={formik}
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          type="number"
          disabled
          placeholder="Enter Export Energy Difference"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Peak Hour Energy TOD1 Difference")}
          name={`meterReadingsData.${index}.peakHourEnergyTOD1Difference`}
          formik={formik}
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          type="number"
          disabled
          placeholder="Enter Peak Hour Energy TOD1 Difference"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Peak Hour Energy TOD5 Difference")}
          name={`meterReadingsData.${index}.peakHourEnergyTOD5Difference`}
          formik={formik}
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          type="number"
          disabled
          placeholder="Enter Peak Hour Energy TOD5 Difference"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Night Hour Energy Difference")}
          name={`meterReadingsData.${index}.nightHourEnergyDifference`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          disabled
          placeholder="Enter Night Hour Energy Difference"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Set Off Import Energy TOD1 Difference")}
          name={`meterReadingsData.${index}.setOffImportEnergyTOD1Difference`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          disabled
          placeholder="Enter Set Off Import Energy TOD1 Difference"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Set Off Export Energy TOD1 Difference")}
          name={`meterReadingsData.${index}.setOffExportEnergyTOD1Difference`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          disabled
          placeholder="Enter Set Off Export Energy TOD1 Difference"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Set Off Import Energy TOD3 Difference")}
          name={`meterReadingsData.${index}.setOffImportEnergyTOD3Difference`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          disabled
          placeholder="Enter Set Off Import Energy TOD3 Difference"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Set Off Export Energy TOD3 Difference")}
          name={`meterReadingsData.${index}.setOffExportEnergyTOD3Difference`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          disabled
          placeholder="Enter Set Off Export Energy TOD3 Difference"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("TOU Discount Energy Difference")}
          name={`meterReadingsData.${index}.touDiscountEnergyDifference`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          disabled
          placeholder="Enter TOU Discount Energy Difference"
        />
      </Grid>
      <Grid item xs={12}>
        <Typography className="mb-3 " lineHeight="1" variant="h6">
          {t("Previous Readings")}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Active Energy")}
          name={`meterReadingsData.${index}.previousMeterReading.activeEnergy`}
          formik={formik}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.activeEnergyDifference`,
              activeEnergy - e.target.value
            );
          }}
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          disabled={!previousMeterReading.id}
          type="number"
          placeholder="Enter Active Energy"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Apparent Energy")}
          name={`meterReadingsData.${index}.previousMeterReading.apparentEnergy`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.apparentEnergyDifference`,
              apparentEnergy - e.target.value
            );
          }}
          disabled={!previousMeterReading.id}
          placeholder="Enter Apparent Energy"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Reactive Energy")}
          name={`meterReadingsData.${index}.previousMeterReading.reactiveEnergy`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.reactiveEnergyDifference`,
              reactiveEnergy - e.target.value
            );
          }}
          disabled={!previousMeterReading.id}
          placeholder="Enter Reactive Energy"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Export Energy")}
          name={`meterReadingsData.${index}.previousMeterReading.exportEnergy`}
          formik={formik}
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.exportEnergyDifference`,
              exportEnergy - e.target.value
            );
          }}
          disabled={!previousMeterReading.id}
          type="number"
          placeholder="Enter Export Energy"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Max Demand")}
          name={`meterReadingsData.${index}.previousMeterReading.maxDemand`}
          formik={formik}
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          disabled={!previousMeterReading.id}
          type="number"
          placeholder="Enter Max Demand"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Peak Hour Energy TOD1")}
          name={`meterReadingsData.${index}.previousMeterReading.peakHourEnergyTOD1`}
          formik={formik}
          disabled={!previousMeterReading.id}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.peakHourEnergyTOD1Difference`,
              peakHourEnergyTOD1 - e.target.value
            );
          }}
          placeholder="Enter Peak Hour Energy TOD1"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Peak Hour Energy TOD5")}
          name={`meterReadingsData.${index}.previousMeterReading.peakHourEnergyTOD5`}
          formik={formik}
          disabled={!previousMeterReading.id}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.peakHourEnergyTOD5Difference`,
              peakHourEnergyTOD5 - e.target.value
            );
          }}
          placeholder="Enter Peak Hour Energy"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Night Hour Energy")}
          name={`meterReadingsData.${index}.previousMeterReading.nightHourEnergy`}
          formik={formik}
          disabled={!previousMeterReading.id}
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.nightHourEnergyDifference`,
              nightHourEnergy - e.target.value
            );
          }}
          type="number"
          placeholder="Enter Night Hour Energy"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Set Off Import TOD1 Energy") + "*"}
          name={`meterReadingsData.${index}.previousMeterReading.setOffImportEnergyTOD1`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.setOffImportEnergyTOD1Difference`,
              setOffExportEnergyTOD1 - e.target.value
            );
          }}
          placeholder="Enter Set Off Import TOD1 Energy"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Set Off Export Energy TOD1") + "*"}
          name={`meterReadingsData.${index}.previousMeterReading.setOffExportEnergyTOD1`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.setOffExportEnergyTOD1Difference`,
              setOffImportEnergyTOD1 - e.target.value
            );
          }}
          placeholder="Enter Set Off Export Energy TOD1"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Set Off Import TOD3 Energy") + "*"}
          name={`meterReadingsData.${index}.previousMeterReading.setOffImportEnergyTOD3`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.setOffImportEnergyTOD3Difference`,
              setOffExportEnergyTOD3 - e.target.value
            );
          }}
          placeholder="Enter Set Off Import TOD3 Energy"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Set Off Export Energy TOD3") + "*"}
          name={`meterReadingsData.${index}.previousMeterReading.setOffExportEnergyTOD3`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.setOffExportEnergyTOD3Difference`,
              setOffImportEnergyTOD3 - e.target.value
            );
          }}
          placeholder="Enter Set Off Export Energy TOD3"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("TOU Discount Energy") + "*"}
          name={`meterReadingsData.${index}.previousMeterReading.touDiscountEnergy`}
          formik={formik}
          type="number"
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e, true) },
          }}
          onChange={(e) => {
            handleChange(e);
            setFieldValue(
              `meterReadingsData.${index}.touDiscountEnergyDifference`,
              touDiscountEnergy - e.target.value
            );
          }}
          placeholder="Enter TOU Discount Energy"
        />
      </Grid>
    </Grid>
  );
};

BillMeterReadingFormItems.propTypes = {
  formik: PropTypes.object,
  meterReading: PropTypes.object,
  index: PropTypes.number,
  t: PropTypes.func,
};
export default withTranslation()(BillMeterReadingFormItems);
